<template>
  <div class="common_concat">
    <el-form class="form" label-width="80px" ref="ruleForm" :rules="rules" :model="concatForm">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="concatForm.name" placeholder="请输入您的姓名"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="tellnumber">
        <el-input v-model="concatForm.tellnumber" placeholder="请输入您的联系电话，方便销售客服联系您~"></el-input>
      </el-form-item>
      <el-form-item label="公司">
        <el-input v-model="concatForm.compname" placeholder="如果方便，可以留下您的工作单位~"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model="concatForm.uemail" placeholder="请留下您的邮箱~"></el-input>
      </el-form-item>
      <el-form-item label="内容" prop="msg">
        <el-input type="textarea"
                  :rows="10"
                  placeholder="请输入咨询内容"
                  v-model="concatForm.msg"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="isLoding?'disabled':isLoding" @click="doAdd()">{{ isLoding?"请"+timeLess+"秒后再咨询":btnName }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'common_concat',
  props:{
    concatName:""
  },
  data() {
    // 手机号正则校验
    const Mobile = (rule, value, callback) => {
      const regMobile = /^((\(\d{2,3}\))|(\d{3}\-))?1[3|5|8]\d{9}$/;
      if (!value) {
        return callback(new Error("请输入手机！"));
      }
      if (!regMobile.test(value)) {
        callback(new Error("您输入手机格式错误！"));
      }else{
        callback();
      }
    };
    return {
      btnName:"提交咨询",
      timeLess:0,
      isLoding:false,
      concatForm:{
        concatname:null,
        compname:null,
        name:null,
        state:1,
        tellnumber:null,
        uemail:null,
        msg:null
      },
      rules:{
        name:[
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
        ],
        tellnumber:[
          {required: true, message: "请填写一下您的手机号码吧~"},
          { validator: Mobile, trigger: "blur" },
          {min: 11, message: '手机号11位哟~是不是不对呀', trigger: 'blur'}
        ],
        msg:[
          { required: true, message: '请输您需要咨询的内容', trigger: 'blur' },
        ]
      }
    }
  },
  methods:{
    // 点击按钮后
    doAdd(){
      let _this = this;

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          _this.addMsg();
        } else {
          return false;
        }
      });


    },
    //提交咨询信息
    addMsg(){
      this.isLoding = true;
      let _this = this;
      this.concatForm.concatname = this.concatName;
      this.$axios.post('/fantis/khmsg/ftKhMsg/add',_this.concatForm)
        .then(function(res){
          if(res.data.code == 200){
            _this.$message.success("留言成功~请耐心等待客户回复");

            _this.timeLess = 60;
            var tt = setInterval(function(){
              _this.timeLess --;
              if(_this.timeLess<=0){
                clearInterval(tt);
                _this.isLoding = false;
              }
            },1000);

          }else{
            _this.$message.error(res.data.msg);
            _this.isLoding = false;
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
          _this.isLoding = false;
        });
    }
  }
}
</script>

<style scoped>
.common_concat{
  width: 80%;
}
.form{
  margin:0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common_concat.vue